import React, { useState, useEffect } from "react";

function Clock({ setLoading }) {
  const [clock, setClock] = useState();

  useEffect(() => {
    setInterval(() => {
      const date = new Date();
      setClock(
        date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
      );
    }, 1000);
  }, []);

  return <div className="clock">{clock}</div>;
}

export default Clock;
